import React from 'react'
import PropTypes from 'prop-types'
import CustomLink from '@shared/components/customLink'
import { getMatchPlayers } from '@shared/libs/match-detail'

export default function FallWicketRow({ fow }) {
  const allPlayers = getMatchPlayers()
  const player = allPlayers[fow?.iBatterId] || fow?.oBatter
  const playerSlug = player?.oSeo?.sSlug
  return (
    <tr>
      <td>{fow?.oBatter?.eTagStatus === 'a' ? (
        playerSlug ? <CustomLink href={`/${playerSlug}`} prefetch={false}><a>{fow?.oBatter?.sFullName || fow?.oBatter?.sShortName}</a></CustomLink> : fow?.oBatter?.sFullName || fow?.oBatter?.sShortName
      ) : fow?.oBatter?.sFullName || fow?.oBatter?.sShortName}
      </td>
      <td>{(fow?.nScoreDismissal !== null || fow?.nScoreDismissal !== undefined) ? fow?.nScoreDismissal : '--'}-{(fow?.nWicketNumber !== null || fow?.nWicketNumber !== undefined) ? fow?.nWicketNumber : '--'}</td>
      <td>{(fow?.sOverDismissal !== null || fow?.sOverDismissal !== undefined) ? fow?.sOverDismissal : '--'}</td>
    </tr >
  )
}

FallWicketRow.propTypes = {
  fow: PropTypes.object
}
